import { forEachTelemetryIntegration } from '@src/telemetry/telemetry-registry'

export function initializeTelemetry() {
  forEachTelemetryIntegration(async (_integrationKey, integration) => {
    await integration.initialize?.()
  })
}
